import React from "react";
import PricingTable from "./PricingTable";
import BoldCell from "./BoldCell";
import Tick from "../Tick";
import { pricingInfo } from "../../data/pricing-page-data";

type ObservabilityTableProps = {
  currency: string
};

const ObservabilityTable: React.FC<ObservabilityTableProps> = ({ currency, ...props }) => {
  return (
    <PricingTable>
      <tbody>
        <tr>
          <BoldCell>Infrastructure metrics</BoldCell>
          <td>
            30 days
          </td>
        </tr>
        <tr>
          <BoldCell>Continuous profiling included</BoldCell>
          <td>
            Past 15 minutes
          </td>
        </tr>
        <tr>
          <BoldCell>Additional continuous profiling</BoldCell>
          <td>
            Past 30 days (with the project add-on at {pricingInfo.continuousProfiling[currency]}/month)
          </td>
        </tr>
        <tr>
          <BoldCell>Blackfire APM and profiler for Python and PHP</BoldCell>
          <td>
            <Tick/>
          </td>
        </tr>
        <tr>
          <BoldCell>HTTP requests analytics</BoldCell>
          <td>
            <Tick />
          </td>
        </tr>
        <tr>
          <BoldCell>Logs forwarding (real-time)</BoldCell>
          <td>
            {pricingInfo.logs[currency]} per GB
          </td>
        </tr>
        <tr>
          <BoldCell>Health notifications and performance weekly report</BoldCell>
          <td>
            <Tick />
          </td>
        </tr>
        <tr>
          <BoldCell>User-defined performance alerts (APM and profiler)</BoldCell>
          <td>
            <Tick/>
          </td>
        </tr>
      </tbody>
    </PricingTable>
  );
};

export default ObservabilityTable;
